/* Practical Life · shared store behaviour: cart drawer (Shopify Ajax cart), account panel, product page. */
(function () {
  'use strict';
  var CFG = window.PL_STORE || {};
  var root = document.documentElement;
  var $ = function (id) { return document.getElementById(id); };
  var rootUrl = (CFG.root || '/').replace(/\/?$/, '/');
  var cartUrl = CFG.cart || '/cart';
  var addUrl = (CFG.cartAdd || '/cart/add') + '.js';
  var changeUrl = (CFG.cartChange || '/cart/change') + '.js';

  /* ---------- money ---------- */
  function money(cents) {
    var f = CFG.moneyFormat || '{{amount}}';
    function delim(n, prec, th, dec) {
      var s = (n / 100).toFixed(prec).split('.');
      return s[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + th) + (s[1] ? dec + s[1] : '');
    }
    var m = f.match(/\{\{\s*(\w+)\s*\}\}/), v;
    switch (m && m[1]) {
      case 'amount_no_decimals': v = delim(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = delim(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = delim(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': v = delim(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': v = delim(cents, 0, ' ', ','); break;
      default: v = delim(cents, 2, ',', '.');
    }
    return f.replace(/\{\{\s*\w+\s*\}\}/, v).replace(/<[^>]*>/g, '');
  }
  function sized(url, w) {
    if (!url) return '';
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=' + w);
    return url + (url.indexOf('?') < 0 ? '?' : '&') + 'width=' + w;
  }

  /* ---------- toast ---------- */
  var toastEl = $('toast'), toastT = null;
  function toast(m) {
    if (!toastEl) return;
    toastEl.textContent = m; toastEl.classList.add('on');
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('on'); }, 2400);
  }

  /* ---------- panels (cart + account share the backdrop) ---------- */
  var backdrop = $('backdrop'), lastFocus = null, openPanel = null;
  var PANELS = { cart: { el: $('drawer'), cls: 'cart-open' }, acct: { el: $('acctDrawer'), cls: 'acct-open' }, srch: { el: $('srch'), cls: 'srch-open' }, filter: { el: $('filterDrawer'), cls: 'filter-open' } };
  function open(name) {
    var p = PANELS[name]; if (!p || !p.el) return false;
    if (openPanel && openPanel !== name) close(true);
    if (!openPanel) lastFocus = document.activeElement;
    openPanel = name;
    root.classList.add(p.cls); p.el.setAttribute('aria-hidden', 'false');
    var x = name === 'srch' ? $('srchInput') : p.el.querySelector('.drawer-x'); if (x) x.focus({ preventScroll: true });
    if (name === 'acct') { var im = p.el.querySelector('img[data-src]'); if (im) { im.src = im.getAttribute('data-src'); im.removeAttribute('data-src'); } }
    return true;
  }
  function close(keepFocus) {
    if (!openPanel) return;
    var p = PANELS[openPanel];
    root.classList.remove(p.cls); p.el.setAttribute('aria-hidden', 'true');
    openPanel = null;
    if (!keepFocus && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  if (backdrop) backdrop.addEventListener('click', function () { close(); });
  document.addEventListener('click', function (e) {
    if (e.target.closest('.drawer-x, [data-close]')) close();
  });
  window.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openPanel) { close(); e.preventDefault(); }
  });

  /* inside Shopify's theme editor the checkout and account pages cannot open; say so instead of doing nothing */
  document.addEventListener('click', function (e) {
    if (!(window.Shopify && window.Shopify.designMode)) return;
    var a = e.target.closest && e.target.closest('a[href]'); if (!a) return;
    if (/\/checkout|\/account|customer_authentication/.test(a.getAttribute('href'))) {
      e.preventDefault(); e.stopPropagation();
      toast('Tema düzenleyicide ödeme ve hesap sayfaları açılmaz. Temayı “Önizle” ile açıp deneyin.');
    }
  }, true);

  var acctBtn = $('acctBtn');
  if (acctBtn && PANELS.acct.el) acctBtn.addEventListener('click', function (e) { e.preventDefault(); open('acct'); });

  /* ---------- cart ---------- */
  var cartBtn = $('cartBtn'), countEl = $('cartCount'), list = $('cartList');
  var foot = $('cartFoot'), totalEl = $('cartTotal'), noteEl = $('cartNote'), checkoutBtn = $('checkout');
  var cart = null, loading = null, failed = false;
  /* v22: discounts show in the cart — the old price struck through on the line, and a "You save" row above the subtotal */
  var saveEl = null;
  if (totalEl && totalEl.parentNode && totalEl.parentNode.parentNode) {
    saveEl = document.createElement('div');
    saveEl.className = 'cart-save';
    saveEl.hidden = true;
    saveEl.innerHTML = '<span></span><b></b>';
    totalEl.parentNode.parentNode.insertBefore(saveEl, totalEl.parentNode);
  }
  function discLabel(t) {
    t = String(t || '');
    if (/FIRST15/i.test(t)) return 'Launch price';
    if (/2-?pack/i.test(t)) return '2-pack discount';
    return t || 'Discount';
  }
  function discTitles(it) {
    var out = [];
    (it.line_level_discount_allocations || []).forEach(function (a) {
      var t = discLabel(a.discount_application && a.discount_application.title);
      if (out.indexOf(t) < 0) out.push(t);
    });
    return out;
  }
  var serverCount = parseInt(countEl && countEl.textContent, 10) || 0;
  /* sample products from the home page live only in this browser and never reach checkout */
  var DEMO_KEY = 'pl-demo-cart-v8';
  var demo = [];
  try { demo = JSON.parse(localStorage.getItem(DEMO_KEY) || '[]') || []; } catch (e) { demo = []; }
  function saveDemo() { try { localStorage.setItem(DEMO_KEY, JSON.stringify(demo)); } catch (e) {} }
  function demoQty() { var n = 0; demo.forEach(function (d) { n += d.qty; }); return n; }

  function fetchCart() {
    if (loading) return loading;
    loading = fetch(cartUrl + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (c) { cart = c; failed = false; loading = null; render(); return c; })
      .catch(function (err) { loading = null; failed = true; render(); throw err; });
    return loading;
  }
  function setCount() {
    var n = (cart ? cart.item_count : serverCount) + demoQty();
    if (countEl) { countEl.textContent = n; countEl.classList.toggle('zero', n === 0); }
    if (cartBtn) cartBtn.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
  }
  function bump() { if (!cartBtn) return; cartBtn.classList.remove('bump'); void cartBtn.offsetWidth; cartBtn.classList.add('bump'); }

  function lineHTML(o) {
    var img = o.img ? '<img src="' + o.img + '" alt="" loading="lazy">' : '<i>' + o.name.charAt(0) + '</i>';
    var pic = o.url ? '<a class="ln-img" href="' + o.url + '" tabindex="-1">' + img + '</a>' : '<span class="ln-img">' + img + '</span>';
    var nm = o.url ? '<a class="nm" href="' + o.url + '"></a>' : '<span class="nm"></span>';
    return pic + '<div class="ln-info">' + nm + '<span class="ct"></span>' +
      '<span class="qty"><button type="button" data-q="-1" aria-label="Decrease quantity">−</button><span></span><button type="button" data-q="1" aria-label="Increase quantity">+</button></span></div>' +
      '<div class="ln-side"><span class="pr"></span><button type="button" class="ln-rm" data-q="0">Remove</button></div>';
  }
  function makeLine(o) {
    var li = document.createElement('li');
    li.className = 'ln' + (o.demo ? ' ln-demo' : '');
    li.innerHTML = lineHTML(o);
    li.querySelector('.nm').textContent = o.name;
    li.querySelector('.ct').textContent = o.meta || '';
    li.querySelector('.qty span').textContent = o.qty;
    var pr = li.querySelector('.pr');
    if (o.was) {
      var was = document.createElement('s');
      was.className = 'was'; was.textContent = o.was;
      pr.appendChild(was); pr.appendChild(document.createTextNode(o.price));
    } else pr.textContent = o.price;
    if (o.disc) {
      var dl = document.createElement('span');
      dl.className = 'ln-disc'; dl.textContent = o.disc;
      li.querySelector('.ln-info').insertBefore(dl, li.querySelector('.qty'));
    }
    if (o.demo) li.setAttribute('data-demo', o.id); else li.setAttribute('data-key', o.key);
    return li;
  }
  function render() {
    setCount();
    if (!list) return;
    var real = cart ? cart.items : [];
    list.innerHTML = '';
    if (!cart && !demo.length) {
      list.innerHTML = failed ? '<li class="cart-loading">Your cart couldn’t be loaded right now. Refresh the page and try again.</li>' : '<li class="cart-loading">Loading your cart…</li>';
      if (foot) foot.hidden = true;
      return;
    }
    if (!real.length && !demo.length) {
      list.innerHTML = '<li class="cart-empty"><b>Your cart is empty.</b><span>Add the products you love to your cart; they’ll be waiting for you here.</span><a class="btn" href="' + (CFG.shop || '/collections/all') + '">Start shopping</a></li>';
      if (foot) foot.hidden = true;
      return;
    }
    real.forEach(function (it) {
      var meta = it.product_has_only_default_variant ? '' : (it.variant_title || '');
      var was = it.original_line_price > it.final_line_price ? money(it.original_line_price) : '';
      list.appendChild(makeLine({ key: it.key, name: it.product_title, meta: meta, qty: it.quantity, price: money(it.final_line_price), was: was, disc: was ? discTitles(it).join(' + ') : '', img: sized(it.image, 200), url: it.url }));
    });
    if (demo.length) {
      var sep = document.createElement('li');
      sep.className = 'ln-sep';
      sep.textContent = 'Sample products · not included at checkout';
      list.appendChild(sep);
      demo.forEach(function (d) {
        list.appendChild(makeLine({ demo: true, id: d.id, name: d.name, meta: d.meta, qty: d.qty, price: money(Math.round(d.price * d.qty * 100)), img: d.img }));
      });
    }
    if (foot) foot.hidden = false;
    var hasReal = real.length > 0;
    if (totalEl) { totalEl.textContent = money(cart ? cart.total_price : 0); totalEl.parentNode.hidden = !hasReal; }
    if (saveEl) {
      var saved = cart && hasReal ? (cart.original_total_price || 0) - (cart.total_price || 0) : 0;
      saveEl.hidden = !(saved > 0);
      if (saved > 0) {
        var labels = [];
        real.forEach(function (it) { discTitles(it).forEach(function (t) { if (labels.indexOf(t) < 0) labels.push(t); }); });
        (cart.cart_level_discount_applications || []).forEach(function (a) { var t = discLabel(a.title); if (labels.indexOf(t) < 0) labels.push(t); });
        saveEl.firstChild.textContent = 'You save' + (labels.length ? ' · ' + labels.join(' + ') : '');
        saveEl.lastChild.textContent = '−' + money(saved);
      }
    }
    if (checkoutBtn) { checkoutBtn.classList.toggle('off', !hasReal); checkoutBtn.setAttribute('aria-disabled', String(!hasReal)); }
    if (noteEl) {
      noteEl.textContent = !hasReal ? 'Sample products can’t be purchased. Add products from the store to check out.'
        : 'Shipping and taxes are calculated at checkout.' + (demo.length ? ' Sample products are not included.' : '');
    }
  }

  function changeLine(key, qty, li) {
    if (li) li.classList.add('busy');
    return fetch(changeUrl, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || r.status); return j; });
    }).then(function (c) { cart = c; render(); })
      .catch(function (err) { if (li) li.classList.remove('busy'); toast(String(err.message || 'Your cart couldn’t be updated.')); });
  }
  if (list) list.addEventListener('click', function (e) {
    var b = e.target.closest('button[data-q]'); if (!b) return;
    var li = b.closest('li'), d = +b.getAttribute('data-q');
    var cur = +li.querySelector('.qty span').textContent;
    var next = d === 0 ? 0 : cur + d;
    if (li.hasAttribute('data-demo')) {
      var id = li.getAttribute('data-demo');
      demo = demo.filter(function (x) { if (x.id === id) x.qty = next; return x.qty > 0; });
      saveDemo(); render(); return;
    }
    changeLine(li.getAttribute('data-key'), next, li);
  });

  if (checkoutBtn) checkoutBtn.addEventListener('click', function (e) {
    if (checkoutBtn.classList.contains('off')) { e.preventDefault(); toast('Add products from the store to check out.'); }
  });
  function openCart() { open('cart'); fetchCart().catch(function () {}); }
  if (cartBtn) cartBtn.addEventListener('click', function (e) { e.preventDefault(); openCart(); });

  /* product forms anywhere on the page add through the Ajax cart and open the drawer */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form.pl-add');
    if (!form || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]'), msg = form.querySelector('.pl-form-msg');
    if (btn) { btn.disabled = true; btn.classList.add('busy'); }
    if (msg) msg.textContent = '';
    fetch(addUrl, {
      method: 'POST', credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      body: new URLSearchParams(new FormData(form))
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'This product couldn’t be added to your cart.'); return j; });
    }).then(function () {
      bump();
      return fetchCart().then(function () { open('cart'); });
    }).catch(function (err) {
      if (msg) msg.textContent = err.message; else toast(err.message);
    }).then(function () {
      if (btn) { btn.classList.remove('busy'); btn.disabled = btn.hasAttribute('data-soldout'); }
    });
  });

  /* a real product added from the home page catalog */
  function addVariant(id, name, qty) {
    return fetch(addUrl, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'This product couldn’t be added to your cart.'); return j; });
    }).then(function () {
      bump(); toast('Added to cart: ' + name);
      return fetchCart().catch(function () {});
    }).catch(function (err) { toast(err.message); throw err; });
  }

  /* the home page's sample products */
  function addDemo(p) {
    var found = demo.filter(function (d) { return d.id === p.id; })[0];
    if (found) found.qty += 1;
    else demo.push({ id: p.id, name: p.name, price: p.price, meta: p.meta || '', img: p.img || '', qty: 1 });
    saveDemo(); render(); bump();
    toast('Added to cart: ' + p.name);
  }

  /* back/forward cache can show a stale count */
  window.addEventListener('pageshow', function (e) { if (e.persisted) fetchCart().catch(function () {}); });
  render();
  /* fill the drawer quietly once the page has settled */
  (window.requestIdleCallback || function (f) { setTimeout(f, 1500); })(function () { fetchCart().catch(function () {}); });

  window.PLStore = { open: openCart, close: close, money: money, addDemo: addDemo, addVariant: addVariant, refresh: fetchCart, toast: toast, isOpen: function () { return !!openPanel; } };

  /* ---------- search window ---------- */
  var srchEl = $('srch'), sInput = $('srchInput'), sList = $('srchList'), sStatus = $('srchStatus'), sForm = $('srchForm');
  var sIntro = sList ? sList.innerHTML : '', sTimer = null, sCtrl = null, sCache = {}, sActive = -1;
  function openSearch(q) {
    if (!srchEl) return;
    if (openPanel && openPanel !== 'srch') close(true);
    open('srch');
    if (typeof q === 'string') { sInput.value = q; runSearch(); }
    /* focus once the window is visible, or the keyboard keeps typing into the page */
    requestAnimationFrame(function () { sInput.focus({ preventScroll: true }); sInput.select(); });
  }
  var srchBtn = $('srchBtn');
  if (srchBtn && srchEl) srchBtn.addEventListener('click', function (e) { e.preventDefault(); openSearch(); });
  if (srchEl) srchEl.addEventListener('click', function (e) {
    if (e.target === srchEl || e.target.classList.contains('srch-inner')) close();
  });
  function esc(t) { return String(t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function mark(title, q) {
    var t = esc(title), words = q.trim().split(/\s+/).filter(function (w) { return w.length > 1; }).map(function (w) { return esc(w).replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); });
    return words.length ? t.replace(new RegExp('(' + words.join('|') + ')', 'gi'), '<mark>$1</mark>') : t;
  }
  function showResults(items, q) {
    sActive = -1;
    if (!items.length) {
      sList.innerHTML = '';
      sStatus.textContent = 'No products found for “' + q + '”. Try a different word.';
      return;
    }
    sStatus.textContent = items.length + (items.length === 1 ? ' product' : ' products');
    sList.innerHTML = items.map(function (p) {
      var img = p.image ? sized(p.image, 240) : '';
      return '<li><a class="srch-item" href="' + esc(p.url) + '">' +
        '<span class="srch-img"' + (img ? ' style="--fill:url(\'' + esc(sized(p.image, 120)) + '\')"' : '') + '>' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</span>' +
        '<span class="srch-txt"><b>' + mark(p.title, q) + '</b><span>' + esc(p.price) + (p.available === false ? ' · Sold out' : '') + '</span></span></a></li>';
    }).join('');
  }
  function fromPredictive(j) {
    var r = (j && j.resources && j.resources.results && j.resources.results.products) || [];
    return r.map(function (p) {
      var min = Math.round(parseFloat(p.price_min != null ? p.price_min : p.price) * 100), max = Math.round(parseFloat(p.price_max != null ? p.price_max : p.price) * 100);
      return { title: p.title, url: p.url, image: (p.featured_image && p.featured_image.url) || p.image || '', price: (max > min ? 'From ' : '') + money(min), available: p.available };
    });
  }
  function fromView(j) {
    return ((j && j.results) || []).map(function (p) {
      return { title: p.title, url: p.url, image: p.image || '', price: (p.varies ? 'From ' : '') + money(p.price), available: p.available };
    });
  }
  function getJSON(url, signal) {
    return fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin', signal: signal })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (t) { return JSON.parse(t); });
  }
  function runSearch() {
    var q = sInput.value.trim();
    clearTimeout(sTimer);
    if (sCtrl) sCtrl.abort();
    if (q.length < 2) { sList.innerHTML = sIntro; sStatus.textContent = 'Discover'; sActive = -1; return; }
    if (sCache[q]) { showResults(sCache[q], q); return; }
    sStatus.textContent = 'Searching…';
    sTimer = setTimeout(function () {
      sCtrl = window.AbortController ? new AbortController() : null;
      var sig = sCtrl && sCtrl.signal, e = encodeURIComponent(q);
      getJSON(rootUrl + 'search/suggest.json?q=' + e + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last', sig)
        .then(fromPredictive)
        .catch(function (err) { if (err.name === 'AbortError') throw err; return []; })
        .then(function (items) {
          if (items.length) return items;
          /* the store's own search, matching word beginnings, when the quick one finds nothing */
          return getJSON(rootUrl + 'search?type=product&view=pl-json&q=' + encodeURIComponent(q.split(/\s+/).join('* ') + '*'), sig).then(fromView).catch(function (err) { if (err.name === 'AbortError') throw err; return []; });
        })
        .then(function (items) { sCache[q] = items; if (sInput.value.trim() === q) showResults(items, q); })
        .catch(function () {});
    }, 180);
  }
  function setActive(i) {
    var items = sList.querySelectorAll('.srch-item'); if (!items.length) return;
    sActive = (i + items.length) % items.length;
    Array.prototype.forEach.call(items, function (a, k) { a.classList.toggle('on', k === sActive); });
    items[sActive].scrollIntoView({ block: 'nearest' });
  }
  if (sInput) {
    sInput.addEventListener('input', runSearch);
    sInput.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(sActive + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(sActive - 1); }
    });
    sForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var items = sList.querySelectorAll('.srch-item');
      var pick = items[sActive >= 0 ? sActive : 0];
      if (pick && sInput.value.trim().length >= 2) location.href = pick.href;
    });
  }
  /* /cart sends visitors here as #cart: the cart opens in its panel */
  if (/^#cart/.test(location.hash)) {
    try { history.replaceState(null, '', location.pathname + location.search); } catch (err) {}
    setTimeout(openCart, 60);
  }

  /* /search sends visitors here as #search=<words> */
  if (srchEl && /^#search/.test(location.hash)) {
    var q0 = decodeURIComponent(location.hash.replace(/^#search=?/, ''));
    try { history.replaceState(null, '', location.pathname + location.search); } catch (err) {}
    setTimeout(function () { openSearch(q0); }, 60);
  }

  /* ---------- home: "About us" as tall as the text beside it ---------- */
  var aboutTitle = document.querySelector('.about-title'), aboutText = document.querySelector('.story-about .about');
  if (aboutTitle && aboutText) {
    /* one word per line, so the two lines can stretch over the paragraphs */
    if (!aboutTitle.querySelector('span')) {
      var words = aboutTitle.textContent.trim().split(/\s+/);
      if (words.length > 1) aboutTitle.innerHTML = words.map(function (w) { return '<span></span>'; }).join('');
      Array.prototype.forEach.call(aboutTitle.querySelectorAll('span'), function (sp, i) { sp.textContent = words[i]; });
      if (words.length === 1) aboutTitle.textContent = words[0];
    }
    var ctx = document.createElement('canvas').getContext('2d');
    /* where text actually sits inside its line box, from the font's own metrics */
    var lineMetrics = function (el, sample) {
      var cs = getComputedStyle(el), fs = parseFloat(cs.fontSize), L = parseFloat(cs.lineHeight);
      if (isNaN(L)) L = fs * 1.2;
      ctx.font = cs.fontStyle + ' ' + cs.fontWeight + ' ' + cs.fontSize + ' ' + cs.fontFamily;
      var m = ctx.measureText(sample);
      var fa = m.fontBoundingBoxAscent || fs * .9, fd = m.fontBoundingBoxDescent || fs * .25, half = (L - fa - fd) / 2;
      return { fs: fs, L: L, base: half + fa, under: half + fd, ink: m.actualBoundingBoxAscent || fs * .7, w: (m.actualBoundingBoxLeft || 0) + (m.actualBoundingBoxRight || m.width) };
    };
    var fitAbout = function () {
      aboutTitle.style.fontSize = '';
      aboutTitle.style.marginTop = '';
      if (innerWidth < 861) return;
      var ps = aboutText.querySelectorAll('p'); if (!ps.length) return;
      var lines = aboutTitle.querySelectorAll('span'), words = lines.length ? Array.prototype.map.call(lines, function (x) { return x.textContent; }) : [aboutTitle.textContent];
      /* right column: cap height of its first line down to the baseline of its last */
      var p0 = lineMetrics(ps[0], 'H'), pN = lineMetrics(ps[ps.length - 1], 'H');
      var topY = ps[0].getBoundingClientRect().top + p0.base - p0.ink;
      var botY = ps[ps.length - 1].getBoundingClientRect().bottom - pN.under;
      var want = botY - topY, col = aboutTitle.parentNode.getBoundingClientRect().width;
      /* heading: ink of the first word down to the baseline of the last, all proportional to its size */
      var m = lineMetrics(aboutTitle, words[0]), r = 1 / m.fs;
      var widest = 0;
      words.forEach(function (w) { widest = Math.max(widest, lineMetrics(aboutTitle, w).w * r); });
      var fs = want / ((words.length - 1) * m.L * r + m.ink * r);
      if (fs * widest > col) fs = col / widest;
      aboutTitle.style.fontSize = fs.toFixed(2) + 'px';
      var k = fs / m.fs, top = aboutTitle.getBoundingClientRect().top;
      aboutTitle.style.marginTop = (topY - (top + (m.base - m.ink) * k)).toFixed(2) + 'px';
    };
    var fitT = null;
    var refit = function () { clearTimeout(fitT); fitT = setTimeout(fitAbout, 80); };
    window.addEventListener('resize', refit);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAbout);
    fitAbout();
  }

  /* ---------- products page: filter panel, sorting ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-open-panel]'); if (!b) return;
    e.preventDefault(); open(b.getAttribute('data-open-panel'));
  });
  var sortSel = $('plSort');
  if (sortSel) sortSel.addEventListener('change', function () {
    var u = new URL(location.href);
    u.searchParams.set('sort_by', sortSel.value); u.searchParams.delete('page');
    location.href = u.toString();
  });
  var filtForm = $('plFilter');
  if (filtForm) filtForm.addEventListener('submit', function () {
    /* empty price boxes would otherwise be sent as empty filters */
    Array.prototype.forEach.call(filtForm.querySelectorAll('input[type="number"]'), function (i) { if (i.value === '') i.disabled = true; });
  });

  /* ---------- policies: one open at a time, the address follows ---------- */
  var pols = document.querySelectorAll('details.pol');
  if (pols.length) {
    var here = location.pathname.replace(/\/$/, '');
    var opened = false;
    Array.prototype.forEach.call(pols, function (d) {
      if (location.hash !== '#policies' && !opened && d.getAttribute('data-url').replace(/\/$/, '') === here) { d.open = true; opened = true; }
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        Array.prototype.forEach.call(pols, function (o) { if (o !== d) o.open = false; });
        try { history.replaceState(null, '', d.getAttribute('data-url')); } catch (err) {}
        var r = d.getBoundingClientRect(), top = (parseFloat(getComputedStyle(root).getPropertyValue('--hh')) || 4.4) * 16 + 12;
        if (r.top < top || r.top > innerHeight * .6) window.scrollTo({ top: scrollY + r.top - top, behavior: 'smooth' });
      });
    });
  }

  /* ---------- product page: the photo, its frame and the page backdrop change together ---------- */
  var main = $('plMain'), stage = $('plStage'), pageBg = $('plBg');
  function setBg(src) {
    if (!pageBg || !src) return;
    var top = pageBg.lastElementChild;
    if (top && top.getAttribute('src') === src) return;
    var im = new Image();
    im.alt = ''; im.className = 'next';
    im.onload = function () {
      pageBg.appendChild(im);
      requestAnimationFrame(function () { requestAnimationFrame(function () { im.classList.add('on'); }); });
      setTimeout(function () { while (pageBg.firstElementChild !== im) pageBg.removeChild(pageBg.firstElementChild); }, 1000);
    };
    im.src = src;
  }
  function showImage(full, fill, bg) {
    if (!main || !full) return;
    if (stage && fill) stage.style.setProperty('--fill', 'url("' + fill + '")');
    setBg(bg);
    main.classList.add('swap');
    var pre = new Image();
    pre.onload = pre.onerror = function () { main.removeAttribute('srcset'); main.removeAttribute('sizes'); main.src = full; main.classList.remove('swap'); };
    pre.src = full;
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.pl-thumb'); if (!t || !main) return;
    showImage(t.getAttribute('data-full'), t.getAttribute('data-fill'), t.getAttribute('data-bg'));
    Array.prototype.forEach.call(document.querySelectorAll('.pl-thumb'), function (x) { x.classList.toggle('on', x === t); });
  });
  var vsel = document.querySelector('.pl-add select[name="id"]');
  if (vsel) vsel.addEventListener('change', function () {
    var o = vsel.options[vsel.selectedIndex], form = vsel.form;
    var price = $('plPrice'), btn = form.querySelector('[type="submit"]');
    if (price) price.innerHTML = o.getAttribute('data-price') + (o.getAttribute('data-compare') ? ' <s>' + o.getAttribute('data-compare') + '</s>' : '');
    var soldout = o.hasAttribute('data-soldout');
    if (btn) { btn.disabled = soldout; btn.toggleAttribute('data-soldout', soldout); btn.textContent = soldout ? 'Sold out' : 'Add to cart'; }
    if (o.getAttribute('data-img')) {
      showImage(o.getAttribute('data-img'), o.getAttribute('data-fill'), o.getAttribute('data-bg'));
      var full = o.getAttribute('data-img');
      Array.prototype.forEach.call(document.querySelectorAll('.pl-thumb'), function (x) { x.classList.toggle('on', x.getAttribute('data-full') === full); });
    }
    try { var u = new URL(location.href); u.searchParams.set('variant', o.value); history.replaceState(null, '', u); } catch (err) {}
  });
})();
